import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'semiBold'
})
export class SemiBoldPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    return value.replace('semiBold', 'class="nx-font-weight-semibold"');
  }

}
